import { useState } from "react";
import PageContainer from "../../Component/Common/Page";
import PageHeader from "../../Component/Common/PageHeader";
import MultiButton from "../../Component/extra/MultiButton";
import UserChannel from "./UserChannel";
import FakeChannel from "./FakeChannel";
import dayjs from "dayjs";

const TabsName = {
  Tab1: "User Channel",
  Tab2: "Fake User Channel",
};

export default function ChannelPage() {
  const [dayAnalytics, setDayAnalytics] = useState("today");
  const [multiButtonSelect, setMultiButtonSelect] = useState("User Channel");
  const [startDate, setStartDate] = useState("All");
  const [endDate, setEndDate] = useState("All");

  const startDateFormat = (startDate) => {
    return startDate && dayjs(startDate).isValid()
      ? dayjs(startDate).format("YYYY-MM-DD")
      : "All";
  };
  const endDateFormat = (endDate) => {
    return endDate && dayjs(endDate).isValid()
      ? dayjs(endDate).format("YYYY-MM-DD")
      : "All";
  };

  const startDateData = startDateFormat(startDate);
  const endDateData = endDateFormat(endDate);

  return (
    <PageContainer className="userPage channelPage">
      <PageHeader
        heading={"Welcome Admin"}
        subHeading={"Channel"}
        showDateRange={true}
        startDate={startDate}
        endDate={endDate}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
      />

      <MultiButton
        label={Object.values(TabsName)}
        multiButtonSelect={multiButtonSelect}
        setMultiButtonSelect={setMultiButtonSelect}
      />

      {multiButtonSelect == TabsName.Tab1 && (
        <UserChannel startDate={startDateData} endDate={endDateData} />
      )}
      {multiButtonSelect == TabsName.Tab2 && (
        <FakeChannel startDate={startDateData} endDate={endDateData} />
      )}
    </PageContainer>
  );
}
